var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-principal'),(_vm.accessApp)?_c('div',[(_vm.getHeader)?_c(_vm.component,{tag:"component",on:{"activarLateral":function($event){_vm.showAside = $event}}}):_vm._e(),(_vm.getHeader)?_c('div',{class:[
                    'page-wrapper', 
                    {show: _vm.showAside}, 
                    {'asidemak-active':_vm.maquetador}
                ]},[_c('router-view')],1):_vm._e()],1):_vm._e(),_c('footer-principal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }